import { Button, Modal, ModalActions, ModalContent, ModalTitle, modalClasses } from "@kaltura/ds-react-components";
import { translate, translatePlural } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

const StyledModal = styled(Modal)({
    [`& .${modalClasses.paper}`]: {
        maxWidth: 584,
    },
});

interface BulkRestoreConfirmationModalProps {
    open: boolean;
    processing: boolean;
    selectedCount: number;
    onClose: () => void;
    onConfirm: () => void;
}

export const BulkRestoreConfirmationModal = ({
    open,
    processing,
    selectedCount,
    onClose,
    onConfirm,
}: BulkRestoreConfirmationModalProps) => {
    const sendButtonAnalytics = useButtonAnalytics();

    const handleRestore = () => {
        sendButtonAnalytics(
            "Confirm bulk restore items",
            ButtonClickAnalyticsType.SAVE,
            undefined,
            "recycle bin",
            "Modal - Recycle bin - Restore items"
        );
        onConfirm();
    };

    const handleCancel = () => {
        sendButtonAnalytics(
            "Cancel bulk restore items",
            ButtonClickAnalyticsType.CLOSE,
            undefined,
            "recycle bin",
            "Modal - Recycle bin - Restore items"
        );
        onClose();
    };

    return (
        <StyledModal open={open} onClose={onClose} maxWidth={false}>
            <ModalTitle>{translate("Restore items")}</ModalTitle>
            <ModalContent>
                {translatePlural(
                    "Are you sure you want to restore %1 item? They will be found where they were originally published.",
                    "Are you sure you want to restore %1 items? They will be found where they were originally published.",
                    [selectedCount]
                )}
            </ModalContent>
            <ModalActions>
                <Button variant="borderless" color="secondary" onClick={handleCancel}>
                    {translate("Cancel")}
                </Button>
                <Button color="primary" onClick={handleRestore} loading={processing} disabled={processing}>
                    {translate("Restore")}
                </Button>
            </ModalActions>
        </StyledModal>
    );
};
